import React from "react";
import { withRedux } from "helpers";
import { Input, P } from "components";
import { borderContainerWebsite } from "../editTemplate.styles";

class EditWebsite extends React.Component {
  updateUrl = url => {
    // TODO: Probably need to revisit this part when there are multiple websites
    const { activeTemplate } = this.props;
    const updatedTemplate = {
      ...activeTemplate
    };
    updatedTemplate.components[0].view.url = url;
    this.props.actions.updateTemplate(updatedTemplate);
  };

  render() {
    const { activeTemplate } = this.props;
    const component = activeTemplate.components[0];
    return (
      <div className={borderContainerWebsite}>
        <Input
          field="https://"
          defaultValue={component.view.url}
          onChange={this.updateUrl}
        />
      </div>
    );
  }
}

export default withRedux(EditWebsite);
